// configReducer.js
import {
  FETCH_REMOTE_CONFIG_REQUEST,
  FETCH_REMOTE_CONFIG_SUCCESS,
  FETCH_REMOTE_CONFIG_FAILURE,
} from "./RemoteConfig";

const initialState = {
  loading: false,
  config: {},
  error: null,
};

const remoteConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REMOTE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_REMOTE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload,
      };
    case FETCH_REMOTE_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default remoteConfigReducer;
